<alert [nom]="NOM_ALERTE_VALIDATION_TELETRAVAIL" class="alerte" nomBouton="GLOBAL.OUI"></alert>

<div class="validation-teletravail">
	<div class="validation-header">
		<label>{{ 'VALIDATION_TELETRAVAIL.FILTRE_SEMAINE_CONCERNEE' | translate }}</label>
		<p-calendar
				[(ngModel)]="periode"
				dateFormat="dd MM yy"
				selectionMode="range"
				[readonlyInput]="true"
				[iconDisplay]="'input'"
				[showIcon]="true"
				(onSelect)="onSelectPeriode()"
				inputId="icondisplay"/>
		<i class="pi pi-times" (click)="onResetSemaineConcernee()"></i>
	</div>

	<div class="validation-container">
		<p-treeTable #evenementsValidation
					 class="tree-table-validation"
					 [value]="donneesTreeTableValidation()"
					 [scrollable]="true"
					 scrollHeight="flex"
					 styleClass="p-treetable-sm"
					 loadingIcon="app-spinner"
					 [loading]="loadingRechercherJoursTeletravail()"
					 [tableStyle]="{'min-width':'800px'}">

			<ng-template pTemplate="header">
				<tr>
					<th>{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_DATE_DEMANDE' | translate }}</th>
					<th ttSortableColumn="nomUtilisateur">
						{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_NOM' | translate }}
						<p-treeTableSortIcon field="nomUtilisateur"></p-treeTableSortIcon>
					</th>
					<th ttSortableColumn="prenomUtilisateur">
						{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_PRENOM' | translate }}
						<p-treeTableSortIcon field="prenomUtilisateur"></p-treeTableSortIcon>
					</th>
					<th>{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_EVENEMENT' | translate }}</th>
					<th>{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_DATE_EVENEMENT' | translate }}</th>
					<th>{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_DUREE' | translate }}</th>
					<th>{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_STATUT' | translate }}</th>
					<th>{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_COMMENTAIRE' | translate }}</th>
					<th>{{ 'VALIDATION_TELETRAVAIL.TABLE.COLONNES.COL_ACTION' | translate }}</th>
				</tr>
				<tr>
					<th>
						<input type="date"
							   class="filtreInputDate"
							   pInputText
							   (input)="onFiltreDateModifiee($event, evenementsValidation, 'dateDemande')"
							   style="width: 60%">
					</th>
					<th>
						<input class="filtreInput" type="text" pInputText (input)="evenementsValidation.filter($event.target.value, 'nomUtilisateur', 'contains')">
					</th>
					<th>
						<input class="filtreInput" type="text" pInputText (input)="evenementsValidation.filter($event.target.value, 'prenomUtilisateur', 'contains')">
					</th>
					<th>
						<div class="filtreStatuts">
							<p-multiSelect
									name="typeEvenement"
									[options]="tousLesTypesEvenements"
									(onChange)="evenementsValidation.filter($event.value, 'typeEvenement.designation', 'in')"
									placeholder=""
									selectedItemsLabel="{{ 'GLOBAL.FILTRES.NB_ELEMENTS_SELECTIONNES' | translate }}"
									showClear="true"
									(onClear)="filtreTypesEvenementTeletravail.set([]); evenementsValidation.filter([], 'typeEvenement.designation', 'in')"
									appendTo="body"
									resetFilterOnHide="true"
									[autoOptionFocus]="false"
									[(ngModel)]="filtreTypesEvenementTeletravail"
							></p-multiSelect>
						</div>					</th>
					<th>
						<input type="date"
							   class="filtreInputDate"
							   pInputText
							   (input)="onFiltreDateModifiee($event, evenementsValidation, 'dateTeletravail')"
							   style="width: 60%">
					</th>
					<th></th>
					<th>
						<div class="filtreStatuts">
							<p-multiSelect
									name="statutEvenement"
									[options]="tousLesStatutsTeletravail"
									(onChange)="evenementsValidation.filter($event.value, 'statut.designation', 'in')"
									placeholder=""
									selectedItemsLabel="{{ 'GLOBAL.FILTRES.NB_ELEMENTS_SELECTIONNES' | translate }}"
									showClear="true"
									(onClear)="filtreStatutsTeletravail.set([]); evenementsValidation.filter([], 'statut.designation', 'in')"
									appendTo="body"
									resetFilterOnHide="true"
									[autoOptionFocus]="false"
									[(ngModel)]="filtreStatutsTeletravail"
							></p-multiSelect>
						</div>
					</th>
					<th></th>
					<th></th>
				</tr>
			</ng-template>

			<ng-template pTemplate="body" let-rowNode let-rowData="rowData">
				<tr [ttRow]="rowNode" [ngClass]="rowData.type === 'parent' ? 'parent-row' : 'child-row'">
					@if (rowData.type === 'parent') {
						<td [attr.colspan]="8" class="parent-cellule-label">
							<div class="label-semaine">
								<p-treeTableToggler [rowNode]="rowNode"></p-treeTableToggler>
								<span>{{ rowData.labelSemaine }}</span>
							</div>
						</td>
						<td class="parent-cellule-actions">
							<div class="actions-masse">
								<p-button
										type="button"
										icon="pi pi-check-circle"
										[title]="'VALIDATION_TELETRAVAIL.TABLE.BTN_TOUT_VALIDER' | translate"
										(onClick)="validerJoursDeTeleTravailPourSemaineConfirmation(rowData.labelSemaine)"
										[disabled]="estBtnSemaineValiderDisabled(rowData.labelSemaine)"
										[loading]="loadingBtnValiderParSemaine().get(rowData.labelSemaine)"/>
								<p-button
										styleClass="refuser-teletravail"
										type="button"
										icon="pi pi-ban"
										[title]="'VALIDATION_TELETRAVAIL.TABLE.BTN_TOUT_REFUSER' | translate"
										(onClick)="refuserJoursDeTeleTravailPourSemaineConfirmation(rowData.labelSemaine)"
										[disabled]="estBtnSemaineRefuserDisabled(rowData.labelSemaine)"
										[loading]="loadingBtnRefuserParSemaine().get(rowData.labelSemaine)"/>
							</div>
						</td>
					}

					@if (rowData.type === 'enfant') {
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							{{ rowData.dateDemande }}
						</td>
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							{{ rowData.nomUtilisateur }}
						</td>
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							{{ rowData.prenomUtilisateur }}
						</td>
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							{{ rowData.typeEvenement.designation }}
						</td>
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							{{ rowData.dateTeletravail }}
						</td>
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							<div class="statut-duree-content">
								<div class="tag-statut-duree tag-duree">
									<span class="duree">{{ rowData.duree.designation }}</span>
								</div>
							</div>
						</td>
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							<div class="statut-duree-content">
								<div class="tag-statut-duree" [ngClass]="determinerClasseTagStatut(rowData.statut)">
									<span class="statut">{{ rowData.statut.designation }}</span>
								</div>
							</div>
						</td>
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							<span class="commentaire" title="{{ rowData.commentaire }}">
								<em>{{ rowData.commentaire }}</em>
							</span>
						</td>
						<td class="child-cellule" [ngClass]="determinerClasseDateDepassee(rowData.labelSemaine, rowData.id)">
							<div class="actions">
								<p-button
										type="button"
										icon="pi pi-check-circle"
										[title]="'VALIDATION_TELETRAVAIL.TABLE.BTN_VALIDER' | translate"
										(onClick)="validerJoursTeletravailUnitaire(rowData.id)"
										[disabled]="estBtnUnitaireValiderDisabled(rowData.labelSemaine, rowData.id, rowData.statut, rowData.typeEvenement)"
										[loading]="loadingBtnValiderParJourTeletravailId().get(rowData.id)"/>
								<p-button
										styleClass="refuser-teletravail"
										type="button"
										icon="pi pi-ban"
										[title]="'VALIDATION_TELETRAVAIL.TABLE.BTN_REFUSER' | translate"
										(onClick)="refuserJoursTeletravailUnitaire(rowData.id)"
										[disabled]="estBtnUnitaireRefuserDisabled(rowData.labelSemaine, rowData.id, rowData.statut, rowData.typeEvenement)"
										[loading]="loadingBtnRefuserParJourTeletravailId().get(rowData.id)"/>
							</div>
						</td>
					}
				</tr>
			</ng-template>

			<ng-template pTemplate="emptymessage">
				<tr>
					<td [attr.colspan]="7">
						{{ 'VALIDATION_TELETRAVAIL.TABLE.AUCUN_JOUR_TELETRAVAIL' | translate }}
					</td>
				</tr>
			</ng-template>
		</p-treeTable>
	</div>
</div>
<confirmation-modal-component #confirmationModalComponent></confirmation-modal-component>
